import { z } from "zod";
import { addressSchema } from "../address/address.schema";

export const substitutionPlanContactNotificationSchema = z.object({
	id: z.uuid(),
	substitutionPlanProjectItemId: z.uuid(),
	contactMemberId: z.uuid().optional(),
});

export const substitutionPlanContactNotificationListSchema = z.object({
	items: z.array(substitutionPlanContactNotificationSchema).default([]),
});

export const substitutionPlanFormItemSchema = z
	.object({
		id: z.uuid(),
		userId: z.string(),
		substitutionPlanId: z.uuid(),
		projectName: z.string(),
		projectNumber: z.string().nullish(),
		projectId: z.uuid(),
		isAssignmentNotRequired: z.boolean(),
		assignedUserIds: z.array(z.string()),
		sppiId: z.uuid(),
		clientName: z.string().nullish(),
		clientId: z.string().nullish(),
		quickNote: z.string().nullish(),
		contactNotifications: z.array(substitutionPlanContactNotificationSchema).default([]),
	})
	.and(addressSchema);

export const substitutionPlanFormSchema = z.array(substitutionPlanFormItemSchema);

export const substitutionPlanFrontendFormSchema = z.object({
	items: substitutionPlanFormSchema,
});

export type SubstitutionPlanFormSchema = z.infer<typeof substitutionPlanFormSchema>;
export type SubstitutionPlanFormItemSchema = z.infer<typeof substitutionPlanFormItemSchema>;
export type SubstitutionPlanFrontendFormSchema = z.infer<typeof substitutionPlanFrontendFormSchema>;
export type SubstitutionPlanContactNotificationSchema = z.infer<
	typeof substitutionPlanContactNotificationSchema
>;
export type SubstitutionPlanContactNotificationListSchema = z.infer<
	typeof substitutionPlanContactNotificationListSchema
>;
